module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("6wP72"))).then(() => parcelRequire('1iHdE'));